import { Inject } from '@odinjs/odin';
import { PanelAPI, PDFViewerAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { resolvePath } from '@philips-internal/oswald-ui-utils';
import { FragmentNames } from '../../codegen';
import { MyChartMedicalDataReportAliases } from '../../codegen';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import UserContext from '../../utils/user-context';
import BaseController from '../BaseController';

interface DeckMedicalDataProps {
  nrSequence: number;
  professional: string;
  read: string;
  type: string;
}

@Controller({ fragment: FragmentNames.MY_CHART_MEDICAL_DATA_REPORT })
export default class MyChartMedicalDataReportController extends BaseController {

  @Inject(MyChartMedicalDataReportAliases.PDF_VIEWER)
    pdfViewerAPI!: PDFViewerAPI;

  @Inject(MyChartMedicalDataReportAliases.PANEL_LOADER)
    panelLoaderAPI!: PanelAPI;

  @OnMount({ target: MyChartMedicalDataReportAliases.LAYOUT_REPORT_MEDICAL_DATA })
  handleMyChartMedicalDataReportLoading(): void {
    const item = this.context.get('itemSelected') as DeckMedicalDataProps;

    const params = {
      nrSequence: item.nrSequence,
      patientId: UserContext.patientId,
      type: item.type
    };

    this.panelLoaderAPI.setVisible(false);
    this.pdfViewerAPI.setSrc(resolvePath(APPLICATION_ENDPOINTS.GET_MC_MEDICAL_DATA_REPORT, params));
    this.pdfViewerAPI.setVisible(true);
  }
}